<template>
  <section v-if="data">
    <PagesJournalsComponent :data="data" />
  </section>
  <SharedErrorComponent v-else-if="error" :error="error" />
</template>

<script lang="ts" setup>
useHead({
  htmlAttrs: { 'data-page-type': 'journals' }
})

const i18nActiveIso = baseI18nGetActiveIso()

const { data, error } = await useAsyncData(() =>
  fetchQueryPath( queryJournalsPage(i18nActiveIso) )
)

basePageSetHead(data)
</script>
